<template>
  <div class="container">
    <div class="topDiv">
          <div class="topDiv_item1"  @click="select(3)">
              <span class="topDiv_item_span1">{{companyName}}</span>
              <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
          </div>
      </div>
      <div class="topDiv">
          <div class="topDiv_item"  @click="select(1)">
              <span class="topDiv_item_span">{{HT}}</span>
              <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
          </div>
          <div class="topDiv_item" @click="select(2)">
              <span class="topDiv_item_span">{{year}}</span>
              <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
          </div>
      </div>
      <div :class="$store.state.common.theme !=3 ? 'shop_list1' :'shop_list2' " v-if="dataList.length>0">
            <!-- viewbuttom
            :allLoaded="allLoaded"   :data="billList" @pulldown="false" @loadUp="loadup"  -->
            <scroll :pullup="false" :pulldown="false" :scrollX="true"  >
                 <section @click="pushToDetail(item)"  class="list_cell" v-for="(item,index) in dataList" :key="index"  >
                      <div class="list_item">
                        <div class="list_item_top_left">
                                <img v-if="item.feeCodeName.indexOf('联合办公')!==-1" class="list_item_top_icon"
                                          src="../../assets/images/icon_bill_other.png" />
                                <img v-else-if="item.feeCodeName.indexOf('电费')!==-1" class="list_item_top_icon"
                                        src="../../assets/images/icon_bill_electric.png" />
                                <img v-else-if="item.feeCodeName.indexOf('租金')!==-1" class="list_item_top_icon"
                                        src="../../assets/images/icon_bill_rent.png" />
                                <img v-else-if="item.feeCodeName.indexOf('水费')!==-1" class="list_item_top_icon"
                                        src="../../assets/images/icon_bill_water.png" />
                                <img v-else-if="item.feeCodeName.indexOf('物业')!==-1" class="list_item_top_icon"
                                        src="../../assets/images/icon_bill_property.png" />
                                <img v-else class="list_item_top_icon"
                                        src="../../assets/images/icon_bill_other.png" />
                                <span class="list_item_top_span1">{{item.feeCodeName}}</span>
                                <span v-if="item.freezeStatus==2" class="redSpan" >{{'冻结'}}</span>
                            </div>
                            <span :class="[item.settleStatus==1?'list_item_span14':'list_item_span13']">{{item.settleStatus==1?'已付':(item.settleStatus==2?'部分缴':'未缴')}}</span>
                      </div> 
                      <div class="list_line"></div>  
                      <div class="list_item">
                         <span class="list_item_span1">客户名称</span>
                         <!-- billCode -->
                         <span class="list_item_span12">{{item.payerName}}</span>
                         <!-- 1 已付 2 部分结清 3 未缴 -->
                        
                      </div>
                     <div class="list_item">
                         <span class="list_item_span1">账单编号</span>
                         <!-- arrearsNo -->
                         <span class="list_item_span12">{{item.billCode}}</span>
                       
                     </div>
                     <div :class="$store.state.common.theme !=3 ? 'list_item' : 'list_item '">
                         <span class="list_item_span1">账单应缴</span>
                         <!-- costAmount -->
                         <span class="list_item_span2">{{item.planAmount.toFixed(2)}}元</span>
                         <span class="list_item_span1">最迟缴款</span>
                         <!-- month | checkMath -->
                         <span class="list_item_span2">{{item.endDate}}</span>
                     </div>
                      <div class="list_item list_item_border_bottom">
                         <span class="list_item_span1">费用期间</span>
                         <!-- arrearsNo -->
                         <span class="list_item_span12">{{item.billStartDate}}-{{item.billEndDate}}</span>
                       
                     </div>

                     <img  v-if="item.waiverAmount && item.waiverAmount>0 &&item.settleStatus!=1" class="list_item_top_icon1" src="../../assets/images/img_overdue.png" />


                 </section>
            </scroll>
       </div>

        <div class="nodataView" v-if="dataList.length==0 &&isLoaded">
             <img class="nodataImage" src="../../assets/images/icon_blank.png"/>
             <span class="nodataspan">无相关账单历史</span>
        </div>

          <!-- // 此处slots为动态传入的值，通过computed来处理，数据通过vuex管理，由于数据为对象数组，需设置 value-key 属性来指定显示的字段名 -->
        <mt-popup  v-model="popupVisible" position="bottom" class="mint-popup">
          <mt-picker class="picker" :slots="pickList" @change="onValuesChange" :visible-item-count="5" 
          
          :show-toolbar="true" ref="picker" >
            <div class="picker_wrap">
                <div class="picker_btn" @click="popupVisible=false">取消</div>
                <div class="picker_btn2" @click="handleConfirm">确认</div>
            </div>
          </mt-picker>
        </mt-popup>
  </div>
</template>
<script>
import { getContractList,geHistoryBillingByParam ,getOnlineBillCompany,getOnlineBillingByParam} from "../../utils/api";
import Scroll from "../../components/scroll";
import util from "../../utils/util";
import storage from '../../utils/storage';
import { mapState } from 'vuex';
export default {
  name: "billDetail",
  components: {
     Scroll,
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  filters: {
    checkMath(val){
      return val?val.split('-')[1]:'';
    }
  },
  data() {
    return {
      activeTab: 1,
      result:'', //合同数组
      dataList: [],
      allLoaded:true,
      isLoaded:false,
      year:'2019',
      yearList:[{
        flex: 1,
        defaultIndex:15,
        values:["2019"] ,
        className: 'slot1',
        textAlign: 'center'
      }],
      //["2019","2018","2017","2016","2015","2014","2013","2012","2011","2010"],
      HT:"全部合同",
      HTId:'',
      //HTNameList:["全部合同","合同1","合同2","合同3","合同4","合同5"],
      HtIdList:["","1","2","3","4","5"],

      HTNameList: [{
        flex: 1,
        defaultIndex:0,
        values:["全部合同"] ,
        className: 'slot1',
        textAlign: 'center'
      }],

      companyId:'',
      companyName:'',
      companyNameList:[],
      companySelectList: [{
        flex: 1,
        values:[] ,
        className: 'slot1',
        textAlign: 'center'
      }],


      //弹框选择
      pickType:'',
      popupVisible:false,
      pickList:[],
    }
  },

  created(){
    var  query = this.$route.query;
    if(query.companyId){
      this.companyId = query.companyId
    }else{
      let data = this.common.userTenantInfoList || [];
      let defaultD = {};
      data.forEach(item => {
        if (item.isDeafult == 1) {
          defaultD = item;
        }
      });
      this.companyId = defaultD.companyId;
      this.companyName =defaultD.company

    }


      this.initYears();
      this.getOnlineBillCompany()
      this.getContractList();
      this.geHistoryBillingByParam();

  },
  methods: {
    getOnlineBillCompany(){
            let params = {
              'userId': this.common.userId,
            }

            getOnlineBillCompany(params).then(res => {
              if (res.res.code === 10000 && res.body) {
                this.companyNameList =res.body

                var nameList =[]
                for(var i=0;i<this.companyNameList.length;i++){
                   if(this.companyNameList[i].companyId ==this.companyId){
                      this.companyName = this.companyNameList[i].companyName
                   }
                    nameList.push(this.companyNameList[i].companyName);
                   // idList.push(this.result[i].localId);
                }
                this.companySelectList[0].values=nameList;
             }

            })

     },

      initYears(){
           var currentDate = new Date();
           var endYear = currentDate.getFullYear();
           var yearList =[];
           endYear =parseInt(endYear);
          //  for(var i= endYear ;i>2009;i--){
          //       yearList.push(i);
          //  }
          for(var i=15;i>=0;i--){ //后15年 和当年
             yearList.push(i+endYear);
          }
          for(var i=1;i<=15;i++){ //前15年
             yearList.push(endYear-i);
           }
           this.yearList[0].values=yearList;
           this.year=endYear;
      },

     getContractList(){
        let params = {
            'userId': this.common.userId,
            companyId:this.companyId,
            "pageNo": 1,
            "pageSize": 100,
            "permissionType": 'BILL'
        }
         getContractList(params).then(res => {
             var nameList =["全部合同"];
             var idList =[];
             if (res.res.code === 10000 && res.body) {
              
                let data = res.body;
                var list = data.contractList;
               
                for(var i=0;i<list.length;i++){
                    for(var j=0;j<list.length- 1 - i;j++){
                      if (list[j].contEndDate<list[j + 1].contEndDate) {
                          [list[j], list[j + 1]] = [list[j + 1], list[j]];
                        }
                    }
                }
                
                this.result =list //data.contractList;
                for(var i=0;i<this.result.length;i++){
                    nameList.push(this.result[i].contNo+'['+util.formatTime(new Date(this.result[i].contBeginDate),6)+'-'+ util.formatTime(new Date(this.result[i].contEndDate),6)+']');
                    idList.push(this.result[i].localId);
                }
             }

             this.HTNameList[0].values=nameList;
             this.HtIdList =idList;
         });


     },

    //上拉
     loadup(){

     },

     //下拉刷新
     loadData(){

     },

     geHistoryBillingByParam(){
          let params = {
            userId: this.common.userId,
            year: String(this.year) ,
            companyId:this.companyId
          }
          if(this.HTId){
            params.contId= this.HTId;
          }
          util.showLoading();
           getOnlineBillingByParam(params).then(res => {
               console.log(res)
               util.hideLoading();
               this.isLoaded= true;
                if (res.res.code == 10000 && res.body) {
                    let data = res.body;
                    var list = data.normalBill;
                    for(var i=0;i<list.length;i++){
                    var item = list[i];
                    if(!item.feeCodeName ||item.feeCodeName==undefined){
                       item.feeCodeName ='其他';
                    }
                }
                    this.dataList = list;
                }else{
                    util.showToast(res.res.msg,2);
                }
           });

     },

     select(pickType){
         this.pickType=pickType;
         this.popupVisible=true;
         if(this.pickType==1){
             this.pickList = this.HTNameList;
         }else if(this.pickType==2){
             this.pickList = this. yearList;
         }else{
          this.pickList =  this.companySelectList
         }

     },
     onValuesChange (picker, values) {
        if (values[0] > values[1]) {
            picker.setSlotValue(1, values[0]);
        }
     },

     handleConfirm(){
        this.popupVisible = false
        var valve =  this.$refs.picker.getValues()[0];
        if(this.pickType==1){
            // this.HT=valve
            var htNames = valve.split('[')
             this.HT=  htNames&&htNames[0]?htNames[0]:valve
            var list =this.HTNameList[0].values;
            for(var i=0;i<list.length;i++){
                if(valve==list[i]){
                    if(i==0){
                        this.HTId='';
                    }else{
                        this.HTId=this.HtIdList[i-1];
                    }
                   // break;
                }
            }
        }else if(this.pickType==2){
            this.year=valve
        }else{
           this.companyName=valve
           this.HTId=''
           this.HT='全部合同'
            var list1 =this.companySelectList[0].values;
            for(var i1=0;i1<list1.length;i1++){
                if(valve==list1[i1]){
                    this.companyId=this.companyNameList[i1].companyId
                    break
                }
            }
            this.getContractList()

        }
        // console.log(this.yeary);
        this.geHistoryBillingByParam();

     },

     pushToDetail(item){
        if(!item.waiverAmount){
           item.waiverAmount=0;
         }
         if(!item.needPayAmount){
           item.needPayAmount=0;
         }
         if(!item.planAmount){
           item.planAmount=0;
         }
          if(!item.realAmount){
           item.realAmount=0;
         }
      //  var param = "contCode="+item.contCode+"&subProjectName="+item.subProjectName+"&endDate="+item.endDate+
      //   "&settleStatus="+item.settleStatus+"&billCode="+item.billCode+'&feeCodeName='+item.feeCodeName+
      //   "&realAmount="+item.realAmount+"&checkStatus="+item.checkStatus+"&reqStatus="+item.reqStatus+
      //   "&feeCode="+item.feeCode+"&subProjectId="+item.subProjectId+"&payerName="+item.payerName+
      //   "&needPayAmount="+item.needPayAmount+"&id="+item.id+"&startDate="+item.billStartDate+"&billEndDate="+item.billEndDate+
      //   "&planAmount="+item.planAmount+"&waiverAmount="+item.waiverAmount;
      //   var url ='/billDetail?' +param;
      //   this.$router.push(url);
       storage.setS('billDetailString', JSON.stringify(item))
        setTimeout(() => {
            var url ='/billDetail';
            //  var url ='/billDetail?' +param;
            this.$router.push(url);
        }, 100)
     },

  }
}

</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: #EDEDED;
  .flex(column);
  .shop_list1 {
    flex: 1;
    height: 500px;
     background-color: #EDEDED;
  }
  .shop_list2{
    flex: 1;
    height: 500px;
     background-color: #EDEDED;
  }
}

.topDiv{
    width: 100%;
    height: 88px;
    flex-direction: row;
    background:#EDEDED;
    display: flex;
}
.topDiv_item{
    height: 88px;
    width: 50%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    display: flex;
}
.topDiv_item1{
    height: 88px;
    width: 100%;
    flex-direction: row;
    padding-left: 28px;
    justify-content: flex-start;
    align-items: center;
    display: flex;

}
.topDiv_item_span1{
    height:40px;
    font-size:32px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.topDiv_item_span{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}

.topDiv_item_icon{
    width: 24px;
    height: 24px;
    margin-left: 16px;
    display: flex;
}

.list_cell{
    width:100%;
    padding-bottom: 28px;
    padding-top: 8px;
    background:#ffffff;
    flex-direction: column;
    display: flex;
    position: relative;
    margin-bottom: 14px;
}
.list_item_top_left{
  flex-direction: row;
  justify-content:flex-start;
  align-items: center;
  
  display: flex;

}
.list_item_top_icon{
    display: flex;
    width: 44px;
    height: 44px;

}
.list_item_top_icon1{
    position: absolute;
    top: 40px;
    right:218px ;
    width: 100px;
    height: 78px;
}
.list_item{
    position: relative;
    margin-top: 20px;
    flex-direction: row;
    margin-left: 28px;
    margin-right: 28px;
    width: 694px;
    display: flex;
}
.list_line{
   margin-left: 28px;
    margin-right: 28px;
    width: 694px;
  height: 1px;
  background-color:rgba(0,0,0,.3) ;
  margin-top: 15px;
  margin-bottom: 5px;
  display: flex;
}
//border-bottom: 1px solid rgba(0,0,0,.3);
.list_item_border_bottom{
  padding-bottom:20px;
  
}
.list_item_span1{
  width: 124px;
  height:34px;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:34px;
  display: flex
}
.list_item_span2{
  width: 223px;
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
  display: flex
}
.redSpan{
  margin-left: 20px;
  margin-top: -7px;
  height:48px;
  font-size:28px;
  line-height:48px;
  padding-left: 10px;
  padding-right: 10px;

  background: #FFF2F0;
  color: red;
}

.list_item_span12{
 
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
  
}
.list_item_span13{
  right: 10px;
 
  position: absolute;
  text-align: right;
  word-break: break-all;
  height:40px;
  font-size:28px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:40px;
  
}

.list_item_span14{
  right: 10px;
  position: absolute;
  
  text-align: right;
  word-break: break-all;
  height:40px;
  font-size:28px;
  font-weight:400;
  color:#FC3F56;
  line-height:40px;
  display: flex

}


//pick
.picker {
    width:100%;
}
.picker-items {
    height: 100px!important;
}
.picker_wrap {
    height: 100px;
    display: flex;
    justify-content: space-between;
    padding: 0 28px;
    box-sizing: border-box;
}
.picker_btn,
.picker_btn2 {
    flex: 1;
    font-size: 32px;
    text-align: left;
    line-height: 100px;
}
.picker_btn2 {
    text-align: right;
    color: @color17;
}

.nodataView{
    width: 100%;
    height: 500px;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;

  }
  .nodataImage{
    width: 200px;
    height: 200px;
  }
  .nodataspan{
      margin-top: 10px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
  }


</style>